import type { ButtonProps } from '@/components/base/button'
import { Button } from '@/components/base/button'
import { Icon } from '@/components/common/icons/Icon'
import { cn } from '@/helpers/utils'

interface ButtonSortAlphaProps extends ButtonProps {
  isAsc: boolean
}

export const ButtonSortAlpha = ({ isAsc, ...props }: ButtonSortAlphaProps) => {
  return (
    <Button className="p-0.5" variant="icon-animated" {...props}>
      <span className="sr-only">
        {/* the next sort state */}
        {isAsc ? 'Sort descending' : 'Sort ascending'}
      </span>

      {/* FIXME: get UX/UI feedback on showing which sort order is active */}
      <div aria-hidden="true" className="relative">
        <div className="absolute inset-0 select-none text-center text-2xs">
          <div
            className={cn(
              'pl-0.5 transition-transform duration-75 ease-linear',
              isAsc ? '-translate-y-1.5' : 'translate-y-[calc(100%-1px)]',
            )}
          >
            {isAsc ? (
              <>
                {/* show up caret */}
                &#9650;
              </>
            ) : (
              <>
                {/* show down caret */}
                &#9660;
              </>
            )}
          </div>
        </div>
        <Icon size="2xl" tag="sort-by-alpha" />
      </div>
    </Button>
  )
}
